import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Typography, Box, Container, CssBaseline, Button, Avatar, FormHelperText, CircularProgress, Tabs, Tab, Card, CardHeader, CardMedia, IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from '../../app/store/actions/authActions';
import { Navigate, NavLink, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { centered_flex_box, MainInput, MainInputLabel, MainPassword, main_button, StyledInput, MainPhone, sec_button } from '../../app/components/Styles';
import { BrandSelect } from '../../app/components/BrandSelect';
import { isMobile } from 'react-device-detect';
import { Image, notification } from 'antd';
import Logo from "../../app/components/logo.png"
import PropTypes from 'prop-types';
import MuiPhoneNumber from 'material-ui-phone-number';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import ImageComponent from '../../app/components/ImageComponent';
import { addNotifications, getPartners } from '../../app/store/actions/imsAdminActions';
import { useEffect } from 'react';

export const CreateNotification = ({ addNotifications, getPartners, partners, user, isLoading }) => {

    const navigate = useNavigate();
    const [selectedPartners, setSelectedPartners] = React.useState([]);
    const [content, setContent] = React.useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        const notificationData = {
            content: content,
            partnerIds: selectedPartners
        }
        
        addNotifications(notificationData, navigate);
    };

    useEffect(() => {
        getPartners({ page: 1, limit: 100 })
    }, [])

    if (isLoading) {
        return (
            <Container maxWidth="xs">
                <Box sx={{ ...centered_flex_box, minHeight: isMobile ? "100%" : "100vh", minWidth: "100%" }}>
                    <CircularProgress sx={{ color: "var(--secColor)" }} />
                </Box>
            </Container>
        )
    }

    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    paddingTop: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box sx={{ width: '100%', mt: 2 }}>
                    <Typography mt={2} variant='h4' textAlign={"center"} sx={{ color: "var(--secColor)" }}>Create Notification</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="content"
                            label="Notification Content"
                            name="content"
                            multiline
                            rows={4}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                        
                        <Typography variant='h6' sx={{ color: "var(--secColor)", mb: 2 }}>Select Partners (Leave empty for all partners)</Typography>
                        
                        <BrandSelect
                            multiple
                            vendors={partners}
                            value={selectedPartners}
                            label="Partners"
                            fullWidth
                            onChange={setSelectedPartners}
                        />
                        
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2, ...main_button }}
                        >
                            Create Notification
                        </Button>
                    </Box>
                </Box>
            </Box >
        </Container >
    );
}

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.records?.isLoading || state?.wait?.isLoading,
    partners: state?.records?.partners
});

const mapDispatchToProps = { getPartners, addNotifications };

export default connect(mapStateToProps, mapDispatchToProps)(CreateNotification);
